export default __webpack_public_path__ + "static/icons-795724c3f428806144d27b1ffead7258.svg";